/**
 * #2919 — clears the account caches (`lib/accountCaches.ts`) when the
 * signed-in account differs from the last one this browser saw. Mounted
 * once under `<AuthProvider/>` in `App.tsx`. Renders nothing.
 */
import { useEffect } from "react";

import { useAuth } from "../lib/AuthContext";
import { noteAccountId } from "../lib/accountCaches";

export function AccountCacheGuard() {
  const { accountId } = useAuth();
  useEffect(() => {
    if (accountId) noteAccountId(accountId);
  }, [accountId]);
  return null;
}
